var React = require('react');
var ReactDOM = require('react-dom');
var Modal = require('react-modal');

var NewEntryForm = require('./NewEntryForm');

var Controller = require('./Controller');
var controller = new Controller();


var appElement = document.getElementById('example');

const customStyles = {
    overlay: {
        zIndex: 100
    },
    content : {
        top         : '50%',
        left        : '50%',
        right       : 'auto',
        bottom      : 'auto',
        marginRight : '-50%',
        transform   : 'translate(-50%, -50%)',
        zIndex: 101
    }
};
const linkMargin = {'margin-left': '4px', 'margin-right': '4px'};

const geoJsonContent = "?url=https://raw.githubusercontent.com/idoco/GitMap/gh-pages/map.geojson";
const renderMapUrl = "https://render.githubusercontent.com/view/geojson"+ geoJsonContent;

var App = React.createClass({displayName: "App",

    getInitialState: function() {
        console.log(controller.isUrlWithCode());
        return {
            modalIsOpen: controller.isUrlWithCode(),
            isAboutOpen: !controller.isUrlWithCode()
        };
    },

    openModal: function() {
        this.setState({modalIsOpen: true});
    },

    closeModal: function() {
        this.setState({modalIsOpen: false});
    },

    closeAbout: function() {
        this.setState({isAboutOpen: false});
    },

    render: function() {
        return (

            React.createElement("div", null, 
                React.createElement("div", {className: "page-content"}, 
                    React.createElement("iframe", {id: "mapFrame", 
                            src: renderMapUrl, 
                            style: {width:'100%', height:'100%', position:'fixed'}}, 
                        "Your browser doesn't support iframes"
                    )
                ), 

                React.createElement("button", {className: "mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect mdl-button--colored", 
                        style: {position: 'fixed', left: '65px', bottom: '65px'}, 
                        onClick: controller.refreshMap}, 
                    React.createElement("i", {id: "refresh-button", className: "material-icons"}, "refresh")
                ), 

                React.createElement("button", {className: "mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect mdl-button--colored", 
                        style: {position: 'fixed', right: '65px', bottom: '65px'}, 
                        onClick: this.openModal}, 
                    React.createElement("i", {id: "submit-button", className: "material-icons"}, "add_location")
                ), 

                React.createElement(Modal, {
                    isOpen: this.state.modalIsOpen, 
                    onRequestClose: this.closeModal, 
                    style: customStyles}, 
                    React.createElement(NewEntryForm, {postNewEntry: controller.postNewEntry, 
                                  isTokenReady: controller.isTokenReady, 
                                  isUrlWithCode: controller.isUrlWithCode}
                    )
                ), 

                React.createElement(Modal, {
                    isOpen: this.state.isAboutOpen, 
                    onRequestClose: this.closeAbout, 
                    style: customStyles}, 
                    React.createElement("div", {style: {width: '360px'}}, 
                        React.createElement("h5", {className: "mdl-dialog__title"}, "GitMap"), 
                        React.createElement("div", {className: "mdl-dialog__content"}, 
                            React.createElement("p", null, 
                                "This demo explores the possibility of building a \"serverless\" location based app by" + ' ' +
                                "using only", 
                                React.createElement("a", {href: "https://help.github.com/articles/mapping-geojson-files-on-github/", 
                                   style: linkMargin}, 
                                    "GitHub's cool ability to render GeoJSON files"
                                ), " as interactive maps, and the" + ' ' +
                                "powerful GitHub API (Nicely wrapped by", 
                                React.createElement("a", {href: "https://github.com/michael/github", 
                                   style: linkMargin}, 
                                    "Github.js"
                                ), ")."
                            ), 
                            React.createElement("p", null, 
                                "The map view is rendered by GitHub from a", 
                                React.createElement("a", {href: "https://github.com/idoco/GitMap/blob/gh-pages/map.geojson", 
                                   style: linkMargin}, 
                                    "GeoJSON file"
                                ), 
                                "stored on GitHub pages and new entries are added to it by forking and creating a pull" + ' ' +
                                "request on behalf of the submitting user. This GitHub \"serverless\" architecture is" + ' ' +
                                "powered by using GitHub itself as the app's database and writing to it by using GitHub's" + ' ' +
                                "API directly from the user's browser."
                            )
                        ), 
                        React.createElement("button", {className: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored", 
                                onClick: this.closeAbout}, 
                            "Close"
                        )
                    )
                )


            )
        );
    }
});

ReactDOM.render(React.createElement(App, null), appElement);



/** WEBPACK FOOTER **
 ** ./App.js
 **/